import { createContext } from 'react';

/**
 * With the advent of subfolder localization, Marketing requires
 * a different URL format than App does. App will use the default
 * `localize` in this context, Marketing will overwrite it with a
 * function that performs the necessary transformation.
 */

const LinkLocalizationContext = /*#__PURE__*/createContext({
  // By default, we pass through without adding the subfolder.
  localize: destination => destination,
  // There are a handful of logged-in pages that use the shared footer
  // (Earn...). In order to avoid showing the locale selector on those
  // pages, we choose to hide the selector by default. Marketing will
  // opt-in.
  hideLocaleSelector: true
});
export { LinkLocalizationContext as default };
//# sourceMappingURL=LinkLocalizationContext.js.map
